import { useHome } from "../../data/content";

function ScrollIndicator() {
  const home = useHome();

  return (
    <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
      <span className="font-sans text-2xs tracking-[0.3em] text-text-muted-light dark:text-text-muted-dark uppercase">
        {home.heroScrollLabel}
      </span>

      <div className="relative w-px h-14 bg-border-light dark:bg-border-dark overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-4 bg-text-muted-light dark:bg-text-muted-dark animate-scroll-dot" />
      </div>
    </div>
  );
}

export default ScrollIndicator;
